import styles from "./TimelineDirectory.module.css";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EditTimelineClip, SetIsHandleKeyboard } from "../../store/actions/TimelineActions";
import { AppState } from "../../../root/RootReducer";
import { createStyles, makeStyles, Modal, Slider } from "@material-ui/core";
import { stringifyVideoTimeWithColons } from "../../../common/video/util/videoTimeStrings";
import { Clip } from "../../models/Timeline";
import { isNull } from "lodash";
import { GetFootageUrlFromClip } from "../../../utils/TimelineUtils";

/**
|--------------------------------------------------
| タイムラインのクリップ編集コンポーネント
|--------------------------------------------------
*/

interface EditClipProps {
    isEditClipModalOpen: boolean;
    setEditClipModalOpen: (flg: boolean) => void;
    clip: Clip;
}
const useStyles = makeStyles(() =>
    createStyles({
        slider: {
            "& .MuiSlider-rail": {
                height: "70px",
                backgroundColor: "#000000",
                opacity: "0.3",
                borderRadius: "5px",
            },
            "& .MuiSlider-track": {
                height: "70px",
                backgroundColor: "#28233E",
            },
            "& .MuiSlider-thumb": {
                width: "30px",
                height: "70px",
                borderRadius: "5px",
                top: "18px",
                backgroundColor: "#9C9C9C",
            },
            "& span:nth-child(4)::after": {
                top: "28px",
                left: "12px",
                right: 0,
                bottom: 0,
                width: "8px",
                height: "8px",
                borderBottom: "2.5px solid #1c1c1c",
                borderLeft: "2.5px solid #1c1c1c",
                borderRadius: 0,
                transform: "rotate(45deg)",
            },
            "& span:nth-child(5)::after": {
                top: "28px",
                left: "8px",
                right: 0,
                bottom: 0,
                width: "8px",
                height: "8px",
                borderBottom: "2.5px solid #1c1c1c",
                borderLeft: "2.5px solid #1c1c1c",
                borderRadius: 0,
                transform: "rotate(-135deg)",
            },
        },
    })
);

export default function EditClip({ isEditClipModalOpen, setEditClipModalOpen, clip }: EditClipProps) {
    const dispatch = useDispatch();
    const classes = useStyles();
    // const [isPlay, setIsPlay] = useState(false);
    const editVideoRef = useRef<HTMLVideoElement>(null);
    const [footageUrl, setFootageUrl] = useState<string>("");
    // 動画の長さ
    const [duration, setDuration] = useState<number>(0);
    const [minRangeValue, setMinRange] = useState<number>(0);
    const [maxRangeValue, setMaxRange] = useState<number>(0);

    const { user, timeline } = useSelector((state: AppState) => ({
        directoryList: state.directory.directoryList,
        footageList: state.timeline.footageList,
        user: state.user.user,
        // footageUrl: state.timeline.footageUrl,
        timeline: state.timeline.timeline?.timeline,
        // isSuccessDeleteClip: state.timeline.isSuccessDeleteClip
    }));

    // 動画の読み込み時、動画の長さと再生時間を設定する。
    const videoOnLoad = () => {
        const video = editVideoRef.current;
        if (video) {
            video.currentTime = Math.round(clip.start) / 1000;
            setMinRange(Math.round(clip.start));
            setMaxRange(Math.floor(clip.end));
            setDuration(Math.floor(video.duration) * 1000);
        }
    };

    // ビデオ編集モーダル閉じる
    const CloseAddClipModal = () => {
        setMinRange(0);
        setMaxRange(0);
        setEditClipModalOpen(false);
        dispatch(SetIsHandleKeyboard(true)); // 編集する際に、キーボードによるvideoのコントロールを無効にする
        // setIsPlay(false);
    };

    // ドラッグ操作で、開始・終了時間を設定
    const handleRangeChange = (event: React.ChangeEvent<{}>, value: number | number[]) => {
        editVideoRef.current?.pause();
        // setIsPlay(false);
        if (typeof value === "object") {
            // クリップの最小値を設定
            if (minRangeValue !== value[0]) {
                setMinRange(Math.round(value[0] / 1000) * 1000);
                if (editVideoRef && editVideoRef.current) {
                    editVideoRef.current.currentTime = Math.round(value[0] / 1000);
                }
            }

            // クリップの最大値を設定
            if (maxRangeValue !== value[1]) {
                setMaxRange(Math.round(value[1] / 1000) * 1000);
                if (editVideoRef && editVideoRef.current) {
                    editVideoRef.current.currentTime = Math.round(value[1] / 1000);
                }
            }
        }
    };

    //クリップ更新
    const handleUpdateClip = () => {
        if (clip.footageId && user && timeline) {
            //クリップを編集する。
            dispatch(
                EditTimelineClip(
                    clip.id,
                    timeline.id,
                    clip.footageId,
                    minRangeValue,
                    maxRangeValue,
                    clip.seq,
                    Number(user.id)
                )
            );
            CloseAddClipModal();
        }
    };

    // let timelineCurrentTime = 0.5; // 秒数
    // const video = editVideoRef.current;
    // const handleVideoOnTimeUpdate = () => {
    //     if (!video) return;

    //     timelineCurrentTime += 0.25;
    //     if (Number.isInteger(timelineCurrentTime)) {
    //         if (Math.round(video.currentTime) === maxRangeValue / 1000) {
    //             // endになったら再生停止
    //             video.pause();
    //         }
    //     }
    // };

    // const handleVideoOnPlay = () => {
    //     if (!video) return;
    //     // リプレイ
    //     if (Math.round(video.currentTime) ===  maxRangeValue / 1000) {
    //         timelineCurrentTime = 0.5;
    //         video.currentTime = minRangeValue / 1000;
    //     }
    // };

    // // Spaceキーによる動画の再生、一時停止
    // const handlePlayPause = (event: KeyboardEvent) => {
    //     if (event.keyCode === 32) {
    //         setIsPlay(!isPlay);
    //     }
    // };

    // // Spaceキーによる動画の再生、一時停止
    // useEffect(() => {
    //     document.addEventListener("keydown", handlePlayPause, false);

    //     if (isPlay) {
    //         editVideoRef.current?.play();
    //     } else {
    //         editVideoRef.current?.pause();
    //     }

    //     return () => {
    //         document.removeEventListener("keydown", handlePlayPause, false);
    //     };
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [isEditClipModalOpen, isPlay]);

    // useEffect(() => {
    //     const video = editVideoRef.current;
    //     if (!video) return;

    //     video.addEventListener("play", handleVideoOnPlay, false);
    //     video.addEventListener("timeupdate", handleVideoOnTimeUpdate, false);
    //     // クリーンアップ
    //     return() => {
    //         video.removeEventListener("play", handleVideoOnPlay, false);
    //         video.removeEventListener("timeupdate", handleVideoOnTimeUpdate, false);
    //     };
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [editVideoRef.current]);

    // clipが変更するたびに実行
    useEffect(() => {
        // 指定位置の再生が出来るフッテージURLを取得
        setFootageUrl(GetFootageUrlFromClip(clip));
    }, [clip]);

    return (
        <>
            {/* クリップを編集するモーダル */}
            <Modal
                className={styles.addClipModal}
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                aria-hidden={false}
                open={isEditClipModalOpen}
                onClose={CloseAddClipModal}
                closeAfterTransition
            >
                <div className={styles.videoArea}>
                    {footageUrl && !isNull(minRangeValue) && !isNull(maxRangeValue) && (
                        <div className={styles.videoAreaBox}>
                            {clip && clip.fileName && (
                                <div className={styles.title}>
                                    {clip.fileName}
                                </div>
                            )}
                            <video
                                id="videoPlayer"
                                ref={editVideoRef}
                                controls
                                // autoPlay
                                controlsList="nodownload"
                                disablePictureInPicture
                                className={styles.video}
                                preload="metadata"
                                onLoadedMetadata={videoOnLoad}
                            >
                                <source
                                    src={
                                        `${
                                            footageUrl + "#t=" + minRangeValue / 1000 + "," + maxRangeValue / 1000
                                        }`
                                    } type="video/mp4" />
                            </video>
                            <div className={styles.durationMillis}>
                                <div>{stringifyVideoTimeWithColons(minRangeValue)}</div>
                                <div>{stringifyVideoTimeWithColons(maxRangeValue)}</div>
                            </div>
                            <Slider
                                max={duration}
                                value={[minRangeValue, maxRangeValue]}
                                onChange={handleRangeChange}
                                style={{
                                    width: "100%",
                                    color: "white",
                                    fontWeight: "bold"
                                }}
                                className={classes.slider}
                            />
                            <div onClick={CloseAddClipModal} className={styles.cancelButton}>
                                キャンセル
                            </div>
                            <div className={styles.addClipButton} onClick={handleUpdateClip}>
                                完了
                            </div>
                        </div>
                    )}
                </div>
            </Modal>
        </>
    );
}
